// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "fe69a73d" + "." + "98425c61d00585e1" + ".js";
};